export const LEGACY_GALLERY_TRANSPARENT_PIXEL =
  'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

export interface LegacyGalleryItem {
  aspectRatio?: number | null;
  isError?: boolean;
  isPreloaded?: boolean;
  renderKey?: string;
  url?: string | null;
  uuid?: string;
}

export type LegacyGallerySelectionMode =
  | 'single'
  | 'multiple'
  | 'none'
  | null
  | undefined;
